import { useSelector } from 'react-redux';

import { RESERVE_BID_LABEL } from 'components/constants';
import { formatAcceptedBidder } from 'components/helpers';
import { formatCurrency } from 'redux/middlewares/live-server/helpers';
import { selectCurrentBid, selectIsHighBidReserveBid } from 'redux/slices/broker/selectors';
import { selectCurrentLot } from 'redux/slices/catalog/selectors';

import styles from './current-bid-high-bidder.module.scss';

export function CurrentBidHighBidder() {
  const currentBid = useSelector(selectCurrentBid);
  const currentLot = useSelector(selectCurrentLot);
  const isHighBidReserveBid = useSelector(selectIsHighBidReserveBid);
  const acceptedBidder = currentLot?.acceptedBidder;
  const paddle = currentLot?.paddle;
  const formattedBidder = formatAcceptedBidder(acceptedBidder, paddle);

  return (
    <>
      <div className={styles['current-bid']}>
        <span>Current Bid:</span>
        <span>{formatCurrency(currentBid)}</span>
      </div>
      <div className={styles['high-bidder']}>
        <span>High Bidder:</span>
        {isHighBidReserveBid ? (
          <span className={styles['reserve-bid']}>{RESERVE_BID_LABEL}</span>
        ) : (
          <span title={acceptedBidder}>{formattedBidder}</span>
        )}
      </div>
    </>
  );
}
